export const PropertySectors = {
    office: 'Office',
    hotel: 'Hotel',
    retail: 'Retail',
    school: 'School'
}
